import { apiClient } from '../http'

/**
 * Сервис для работы с игрой "Мины"
 */
export const minesService = {
    async getBetConfig() {
        const response = await apiClient.get('/mines/bet-config')
        return response.data
    },

    async createGame(bet, minesCount = 3) {
        const response = await apiClient.post('/mines/game', {
            bet,
            minesCount,
        })
        return response.data
    },

    /**
     * Открытие клетки
     */
    async revealCell(gameId, cellIndex) {
        const response = await apiClient.post(`/mines/game/${gameId}/reveal`, {
            cellIndex,
        })
        return response.data
    },

    /**
     * Забрать выигрыш (кэшаут)
     */
    async cashout(gameId) {
        const response = await apiClient.post(`/mines/game/${gameId}/cashout`)
        return response.data
    },

    /**
     * Получение текущей активной игры
     */
    async getCurrentGame() {
        const response = await apiClient.get('/mines/current')
        return response.data
    },

    /**
     * Получение истории игр
     */
    async getGameHistory(params = {}) {
        const response = await apiClient.get('/mines/history', { params })
        return response.data
    },
}
